import React from 'react';
import { Alert, Button, Select, Space, Spin, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useCC } from '../../contexts/CCContext';
import { ccGeoserverOrigin } from '../../services/CCGeoService';
import CCPublicationControls from './CCPublicationControls';

export function CCAvailability() {
  const { status, retry, selection } = useCC();
  const { t } = useTranslation('translation');
  if (status === 'loading' || status === 'idle') return <Spin size="small" aria-label={t('cc.loading')} />;
  if (status !== 'ready') return <Alert type={status === 'error' ? 'error' : 'warning'} showIcon
    message={t(`cc.${status}`, { year: selection.year || '—' })}
    action={status === 'error' ? <Button size="small" onClick={retry}>{t('cc.retry')}</Button> : null} />;
  if (!ccGeoserverOrigin()) return <Alert type="warning" showIcon message={t('cc.mapUnconfigured')} />;
  return null;
}

export default function CCControls() {
  const cc = useCC();
  if (cc.transport === 'v2') return <CCPublicationControls />;
  return <LegacyCCControls />;
}

function LegacyCCControls() {
  const { metadata, dataset, selectDataset, status } = useCC();
  const cc = useCC();
  const { t } = useTranslation('translation');
  return <Space direction="vertical" size={4} className="cc-controls">
    <Space wrap>
      <Typography.Text strong>{t('general.crop_intelligence')}</Typography.Text>
      <Select aria-label={t('cc.year')} placeholder={t('cc.selectYear')} value={dataset?.id}
        disabled={!metadata?.datasets.length || status === 'loading'} style={{ minWidth: 120 }}
        options={metadata?.datasets.map((item) => ({ value: item.id, label: String(item.year) })) || []}
        onChange={selectDataset} />
    </Space>
    <CCAvailability />
    {cc.setTransport && <Button type="link" size="small" onClick={() => cc.setTransport('v2')}>{t('ci.publications')}</Button>}
  </Space>;
}
